export const API_ROOT = process.env.REACT_APP_API_ROOT || 'http://localhost:4000';
